const STORAGE_KEY = 'pixelcraft_cookie_consent';

export const COOKIE_CATEGORIES = ['necessary', 'analytics', 'marketing', 'functional'];

export function getCookieConsent() {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;

  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function saveCookieConsent(categories = {}) {
  const consent = {
    necessary: true,
    analytics: !!categories.analytics,
    marketing: !!categories.marketing,
    functional: !!categories.functional,
    timestamp: new Date().toISOString(),
  };

  localStorage.setItem(STORAGE_KEY, JSON.stringify(consent));
  window.dispatchEvent(new CustomEvent('pixelcraft:cookie-consent-changed', { detail: consent }));

  return consent;
}

export function hasConsent(category) {
  if (category === 'necessary') return true;

  const consent = getCookieConsent();
  return !!consent?.[category];
}

export function resetCookieConsent() {
  localStorage.removeItem(STORAGE_KEY);
  window.dispatchEvent(new CustomEvent('pixelcraft:cookie-consent-changed', { detail: null }));
}
